import React from 'react';
import { InviteComponent } from '../../components';
import { Logo } from '../../Assets';

import './invite.scss';

const Invite = () => {
  return (
    <div>
      <div className="invite-logo-wrapper">
        <Logo width={173} height={34} />
      </div>
      <div className="main-invite-wrapper">
        <InviteComponent />
      </div>
    </div>
  );
};

export default Invite;
